import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
import states from './states'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/countries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/countries/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::store
* @see app/Http/Controllers/Admin/Locations/CountryController.php:29
* @route '/dashboard/locations/countries'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/dashboard/locations/countries',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::store
* @see app/Http/Controllers/Admin/Locations/CountryController.php:29
* @route '/dashboard/locations/countries'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::store
* @see app/Http/Controllers/Admin/Locations/CountryController.php:29
* @route '/dashboard/locations/countries'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::store
* @see app/Http/Controllers/Admin/Locations/CountryController.php:29
* @route '/dashboard/locations/countries'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::store
* @see app/Http/Controllers/Admin/Locations/CountryController.php:29
* @route '/dashboard/locations/countries'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
export const edit = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/countries/{country}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
edit.url = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { country: args }
    }

    if (Array.isArray(args)) {
        args = {
            country: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        country: args.country,
    }

    return edit.definition.url
            .replace('{country}', parsedArgs.country.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
edit.get = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
edit.head = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
const editForm = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
editForm.get = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/countries/{country}/edit'
*/
editForm.head = (args: { country: string | number } | [country: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::update
* @see app/Http/Controllers/Admin/Locations/CountryController.php:54
* @route '/dashboard/locations/countries/{country}'
*/
export const update = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/locations/countries/{country}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::update
* @see app/Http/Controllers/Admin/Locations/CountryController.php:54
* @route '/dashboard/locations/countries/{country}'
*/
update.url = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { country: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { country: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            country: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        country: typeof args.country === 'object'
        ? args.country.id
        : args.country,
    }

    return update.definition.url
            .replace('{country}', parsedArgs.country.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::update
* @see app/Http/Controllers/Admin/Locations/CountryController.php:54
* @route '/dashboard/locations/countries/{country}'
*/
update.put = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::update
* @see app/Http/Controllers/Admin/Locations/CountryController.php:54
* @route '/dashboard/locations/countries/{country}'
*/
const updateForm = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::update
* @see app/Http/Controllers/Admin/Locations/CountryController.php:54
* @route '/dashboard/locations/countries/{country}'
*/
updateForm.put = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::destroy
* @see app/Http/Controllers/Admin/Locations/CountryController.php:72
* @route '/dashboard/locations/countries/{country}'
*/
export const destroy = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/locations/countries/{country}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::destroy
* @see app/Http/Controllers/Admin/Locations/CountryController.php:72
* @route '/dashboard/locations/countries/{country}'
*/
destroy.url = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { country: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { country: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            country: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        country: typeof args.country === 'object'
        ? args.country.id
        : args.country,
    }

    return destroy.definition.url
            .replace('{country}', parsedArgs.country.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::destroy
* @see app/Http/Controllers/Admin/Locations/CountryController.php:72
* @route '/dashboard/locations/countries/{country}'
*/
destroy.delete = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::destroy
* @see app/Http/Controllers/Admin/Locations/CountryController.php:72
* @route '/dashboard/locations/countries/{country}'
*/
const destroyForm = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CountryController::destroy
* @see app/Http/Controllers/Admin/Locations/CountryController.php:72
* @route '/dashboard/locations/countries/{country}'
*/
destroyForm.delete = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const countries = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    states: Object.assign(states, states),
}

export default countries